import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { OwlCarousel } from 'ngx-owl-carousel';

declare let cordova;

@Component({
	selector: 'app-slider',
	templateUrl: './slider.component.html',
	styleUrls: ['./slider.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Slider Component.
 */
export class SliderComponent implements OnInit
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * Cordova.
	 */
	public cordova;

	/**
	 * Slides.
	 */
	@Input()
	public slides: Array<string> = [];

	/**
	 * Class.
	 */
	@Input()
	public class: string = '';

	/**
	 * ViewChild: OwlCarousel.
	 */
	@ViewChild('owlElement')
	public slider: OwlCarousel;

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		// Cordova.
		if ((<any>window).cordova)
		{
			this.cordova = (<any>window).cordova;
		}
	}

	/**
	 * Eventhandler: Previous.
	 */
	public onPrev()
	{
		this.slider.previous();
	}

	/**
	 * Eventhandler: Next slide.
	 */
	public onNext()
	{
		this.slider.next();
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/slider/slider.component.ts